import { combineReducers } from 'redux';
import { StudentState } from './types';
import { coreReducer } from './core/reducer';
import { personalInfoReducer } from './personalInfo/reducer';
import { historyReducer } from './history/reducer';
import { financialsReducer } from './finanacials/reducer';
import { consentsReducer } from './consents/reducer';
import { documentsReducer } from './documents/reducer';
import { financeDocumentsReducer } from './financeDocuments/reducer';
import { preCasInterviewReducer } from './preCasInterview/reducer';
import { SummaryReducer } from './summary/reducer';
import { riskReducer } from './risks/reducer';
import { messagesReducer } from './messages/reducer';
import { visaPrepFormReducer } from './visaPrepForm/reducer';
import { importDataReducer } from './importData/reducer';
import { conflictHistoryReducer } from './conflictHistory/reducer';
import { StudentConfigReducer } from './config/reducer';
import { AuditLogReducer } from './auditLog/reducer';
import { followUpDocumentsReducers } from './followUpDocuments/reducer';
import { MrzDataReducer } from './mrzData/reducer';
import { enrolmentStatusReducer } from './enrolmentStatus/reducer';
import { emailsReducer } from './emails/reducer';
import { offerReducer } from './offer/reducer';
import { calendlyEventsReducer } from './calendlyEvents/reducer';

export const reducer = combineReducers<StudentState>({
  core: coreReducer,
  offer: offerReducer,
  personalInfo: personalInfoReducer,
  history: historyReducer,
  financials: financialsReducer,
  consents: consentsReducer,
  documents: documentsReducer,
  financeDocuments: financeDocumentsReducer,
  followUpDocuments: followUpDocumentsReducers,
  enrolmentStatus: enrolmentStatusReducer,
  preCasInterview: preCasInterviewReducer,
  visa: visaPrepFormReducer,
  summary: SummaryReducer,
  risks: riskReducer,
  messages: messagesReducer,
  importData: importDataReducer,
  conflictHistory: conflictHistoryReducer,
  config: StudentConfigReducer,
  auditLog: AuditLogReducer,
  mrzData: MrzDataReducer,
  emails: emailsReducer,
  calendlyEvents: calendlyEventsReducer,
});

export { reducer as studentReducer };
